export const INITIAL_BREADCRUMBS_DOM_ID = '__ssr_product_breadcrumbs__'

export const encodeScriptJson = (payload: unknown): string => JSON.stringify(payload).replace(/</g, '\\u003c')
